import React, { useRef, useState, useEffect } from "react";
import { InfoBoxContainer, TitleContainer, Title, Subtitle, LinksContainer, StyledMarquee } from "./info-box-styles";
import { IconLink } from "../icon-link/IconLink";
import { MOBILE_WIDTH } from "../../constants";
import { useMediaQuery } from "../../hooks";
import uuid from "react-uuid";
import Skeleton from "../skeleton/Skeleton";

export const InfoBox = ({ title, subtitle, subtitleUrl, links }) => {
  const boxRef = useRef();
  const subRef = useRef();
  const titleRef = useRef();
  const linksRef = useRef();
  const [isSubMarqueeEnabled, setIsSubMarqueeEnabled] = useState(false);
  const [isTitleMarqueeEnabled, setIsTitleMarqueeEnabled] = useState(false);
  const isMobileView = useMediaQuery(MOBILE_WIDTH);
  const reduction = isMobileView ? 32 : 64;

  const checkTitleMarquee = () => {
    if (
      boxRef?.current &&
      titleRef?.current &&
      linksRef?.current &&
      boxRef?.current?.clientWidth - reduction <= titleRef.current?.clientWidth + linksRef.current?.clientWidth &&
      !isTitleMarqueeEnabled
    ) {
      setIsTitleMarqueeEnabled(true);
    } else {
      setIsTitleMarqueeEnabled(false);
    }
  };

  const checkSubMarquee = () => {
    if (
      boxRef?.current &&
      subRef?.current &&
      boxRef?.current?.clientWidth - reduction <= subRef?.current?.clientWidth &&
      !isSubMarqueeEnabled
    ) {
      setIsSubMarqueeEnabled(true);
    } else {
      setIsSubMarqueeEnabled(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      checkTitleMarquee();
    }, 1000);
    //  eslint-disable-line
  }, [boxRef, titleRef, linksRef, reduction, title]);

  useEffect(() => {
    setTimeout(() => {
      checkSubMarquee();
    }, 1000);
    //  eslint-disable-line
  }, [boxRef, subRef, reduction, subtitle]);

  useEffect(() => {
    window.addEventListener("resize", checkTitleMarquee);
    window.addEventListener("resize", checkSubMarquee);
    return () => {
      window.removeEventListener("resize", checkTitleMarquee);
      window.removeEventListener("resize", checkSubMarquee);
    };
    //  eslint-disable-line
  }, []);

  return (
    <InfoBoxContainer ref={boxRef}>
      {title && subtitle ? (
        <>
          <TitleContainer>
            {isTitleMarqueeEnabled ? (
              <StyledMarquee speed={10} gradientWidth={2} delay={3}>
                <Title ref={titleRef}>
                  {title}
                  &emsp;
                </Title>
              </StyledMarquee>
            ) : (
              <Title ref={titleRef}>{title}</Title>
            )}
            <LinksContainer ref={linksRef}>
              {links?.map(({ url, icon, size }) => {
                return <IconLink url={url} icon={icon} color="#000" size={size || "32px"} key={uuid()} />;
              })}
            </LinksContainer>
          </TitleContainer>
          {isSubMarqueeEnabled ? (
            <StyledMarquee speed={10} gradientWidth={2} delay={3} $hover>
              <Subtitle target="_blank" href={subtitleUrl} ref={subRef}>
                {subtitle}
                &emsp;
              </Subtitle>
            </StyledMarquee>
          ) : (
            <Subtitle target="_blank" href={subtitleUrl} ref={subRef} $hover>
              {subtitle}
            </Subtitle>
          )}
        </>
      ) : (
        <Skeleton>
          <rect x="0" y="0" rx="4" ry="4" width="50%" height="20" />
          <rect x="0" y="70%" rx="4" ry="4" width="100%" height="20" />
        </Skeleton>
      )}
    </InfoBoxContainer>
  );
};
